export default {
  home: {
    hero: {
      title: 'كاميرات مراقبة وأنظمة إنذار للأفراد والشركات',
      subtitle: 'تخطط SSG Signaltechnik وتركّب وتدير أنظمة مراقبة بالفيديو وأنظمة إنذار حديثة في كامل منطقة راين-ماين – من هاينبورغ مرورًا بأوفنباخ وفرانكفورت وهاناو وصولًا إلى دارمشتات وغروس-غيراو. مصمّمة بشكل فردي بما يناسب ممتلكاتك ومتطلباتك والمناطق التي تحتاج فعلًا إلى الحماية.',
      ctaPrimary: 'اطلب استشارة أولى مجانية',
      ctaSecondary: 'ابدأ مخطط الكاميرات',
    },
    trust: {
      '0': 'تخطيط فردي',
      '1': 'تركيب احترافي',
      '2': 'إعداد التطبيق',
      '3': 'عناية شخصية',
      '4': 'أفراد وشركات',
    },
    service: {
      eyebrow: 'نهجنا',
      title: 'أكثر من مجرد تركيب كاميرات',
      lead: 'كل مبنى يختلف عن الآخر. لذلك ندرس وضعك بدقة قبل اقتراح أي كاميرا. تشمل الخدمة الكاملة:',
      steps: {
        '0': 'تحليل الاحتياجات والمبنى',
        '1': 'اختيار نوع الكاميرا وزاوية الرؤية',
        '2': 'فحص النقاط العمياء المحتملة',
        '3': 'تخطيط التمديدات والشبكة والتسجيل',
        '4': 'التركيب والتوجيه بشكل احترافي',
        '5': 'إعداد تطبيق الهاتف والوصول عن بُعد',
        '6': 'تدريب العميل بشكل واضح',
        '7': 'صيانة النظام عند الطلب',
      },
      more: 'اكتشف جميع الخدمات',
    },
    solutions: {
      eyebrow: 'أنواع المباني',
      title: 'حلول لكل مبنى',
      lead: 'سواء كان منزلًا أو متجرًا أو قاعة إنتاج – نجد الحل المناسب لمتطلباتك.',
      filter: { alle: 'الكل', privat: 'خاص', gewerbe: 'شركات', innen: 'داخلي', aussen: 'خارجي', neu: 'نظام جديد' },
      more: 'اعرف المزيد',
      viewAll: 'عرض جميع الحلول',
    },
    area: {
      eyebrow: 'منطقة الخدمة',
      title: 'كاميرات مراقبة وأنظمة إنذار في كامل منطقة راين-ماين',
      lead: 'من مقرّنا في هاينبورغ نغطي كامل المنطقة الحضرية: فرانكفورت وأوفنباخ وهاناو ودارمشتات وغروس-غيراو وجميع البلديات المجاورة. تخطيط وتركيب وصيانة كاميرا المراقبة أو نظام الإنذار لديك – دائمًا بشكل شخصي وفي الموقع.',
      viewAll: 'عرض جميع مناطق الخدمة',
    },
    tech: {
      eyebrow: 'التخطيط التقني',
      title: 'التقنية المناسبة للهدف الصحيح',
      lead: 'ليست الميجابكسل وحدها ما يهم. ينشأ نظام الكاميرات الجيد من تفاعل عوامل كثيرة.',
      points: {
        '0': { title: 'داخلي أو خارجي', desc: 'الرطوبة والطقس ودرجة الحرارة تحدد اختيار الكاميرا.' },
        '1': { title: 'الضوء وظروف الليل', desc: 'حلول نهار/ليل وإضاءة منخفضة لكل حالة إضاءة.' },
        '2': { title: 'نظرة عامة أو تمييز التفاصيل', desc: 'زاوية واسعة للنظرة الشاملة أو تقريب للوجوه ولوحات السيارات.' },
        '3': { title: 'المسافة وارتفاع التركيب', desc: 'كلما زاد الارتفاع والبعد، زادت الحاجة إلى دقة أعلى وعدسة أفضل.' },
        '4': { title: 'زاوية الرؤية والعدسة', desc: 'بُعد بؤري ثابت أو متغير أو آلي، حسب الغرض.' },
        '5': { title: 'التسجيل والتخزين', desc: 'مسجّل محلي مع تخزين على القرص حسب الحاجة.' },
        '6': { title: 'الوصول عبر التطبيق', desc: 'عرض مباشر وإعادة تشغيل عبر الهاتف، حسب النظام.' },
        '7': { title: 'إشعارات الأحداث', desc: 'رسائل دفع عند الحركة أو أحداث قابلة للتحديد، حسب النظام.' },
        '8': { title: 'قابلية التوسعة', desc: 'يمكن عادةً توسعة الأنظمة الحالية بكاميرات إضافية.' },
      },
    },
    process: {
      eyebrow: 'سير العمل',
      title: 'كيف يسير مشروعك',
      lead: 'من الطلب الأول حتى النظام الجاهز – بشفافية وشخصيًا.',
      steps: {
        '0': { title: 'المقابلة الأولى', desc: 'نناقش احتياجاتك ومبنىك والمناطق التي ترغب في مراقبتها.' },
        '1': { title: 'المعاينة والتخطيط', desc: 'موعد في الموقع لتحليل الضوء والزوايا ونقاط التركيب والتمديدات.' },
        '2': { title: 'عرض فردي', desc: 'تحصل على عرض شفاف بالتقنية المناسبة ونطاق واضح للخدمات.' },
        '3': { title: 'التركيب والإعداد', desc: 'تركيب احترافي وربط بالشبكة وإعداد المسجّل والتطبيق.' },
        '4': { title: 'التدريب والمتابعة', desc: 'تتعلم طريقة التشغيل. نحن بجانبك حتى بعد ذلك.' },
      },
    },
    refs: {
      eyebrow: 'مشاريع مرجعية',
      title: 'مشاريع منجزة',
      lead: 'مقتطفات من محفظة أعمالنا – من العقارات الخاصة إلى المنشآت التجارية.',
      viewAll: 'اكتشف جميع الحلول',
      items: {
        '0': { label: 'منزل خاص – مسكن عائلي', desc: 'نظام متكامل مع 6 كاميرات ومسجّل وربط بالتطبيق' },
        '1': { label: 'تجارة – بوتيك', desc: 'صالة البيع والمستودع مع 4 كاميرات ورؤية ليلية' },
        '2': { label: 'لوجستيات – مستودع', desc: 'مراقبة مساحات واسعة بزاوية عريضة وكاميرا PTZ' },
        '3': { label: 'عيادة – استقبال طبي', desc: 'مراقبة داخلية سرية مع إخفاء مناطق الخصوصية' },
        '4': { label: 'عقارات – عمارة سكنية', desc: 'المدخل والمرافق الخارجية مع لافتات إرشادية' },
      },
    },
    care: {
      eyebrow: 'الصيانة والعناية',
      title: 'SSG Care',
      lead: 'يجب أن تعمل تقنية الكاميرات لديك بشكل موثوق على المدى الطويل. مع SSG Care تحصل على اشتراك عناية مرن – قابل للإلغاء شهريًا أو بمدة متفق عليها.',
      list: {
        '0': 'فحوصات دورية للنظام وتحديثات البرامج الثابتة',
        '1': 'دعم في مشكلات التطبيق والوصول',
        '2': 'مساعدة عند تغيير الهاتف',
        '3': 'فحص التسجيل والتخزين',
        '4': 'معالجة ذات أولوية حسب الاتفاق',
      },
      cta: 'اكتشف SSG Care',
    },
    planner: {
      eyebrow: 'أداة تفاعلية',
      title: 'مخطط الكاميرات SSG',
      lead: 'ارسم الغرف أو المساحات، وحدّد مناطق المراقبة المهمة، وجرّب مواضع الكاميرات الممكنة مع مخاريط الرؤية. النتيجة خطة أولية غير ملزمة لمحادثتك معنا.',
      list: {
        '0': 'رسم الغرف والجدران',
        '1': 'وضع رموز الكاميرات بالسحب والإفلات',
        '2': 'مخاريط رؤية قابلة للتدوير مع تقييم التغطية',
        '3': 'تحديد مناطق المراقبة والخصوصية',
        '4': 'إرسال النتيجة كطلب أو طباعتها',
      },
      cta: 'ابدأ مخطط الكاميرات',
    },
    faq: {
      eyebrow: 'أسئلة شائعة',
      title: 'ما يسألنا عنه العملاء كثيرًا',
      viewAll: 'عرض جميع الأسئلة',
      items: {
        '0': { question: 'كم كاميرا أحتاج؟', answer: 'يعتمد ذلك على حجم المبنى والمناطق المراد مراقبتها ومستوى التفاصيل المطلوب. بعد المقابلة الأولى والمعاينة نُعدّ لك اقتراحًا فرديًا.' },
        '1': { question: 'هل يمكنني مشاهدة الكاميرات على الهاتف؟', answer: 'نعم، مع معظم الأنظمة الحديثة يمكن الوصول عبر تطبيق الهاتف. نُعدّ اتصال التطبيق مباشرة أثناء التركيب.' },
        '2': { question: 'هل تعمل الكاميرات في الظلام؟', answer: 'نعم، للمناطق الخارجية والداخلية ضعيفة الإضاءة توجد كاميرات نهار/ليل وإضاءة منخفضة مع رؤية ليلية بالأشعة تحت الحمراء أو بالألوان.' },
        '3': { question: 'كم تبلغ تكلفة نظام الكاميرات؟', answer: 'تعتمد التكلفة على عدد الكاميرات والمبنى والتمديدات ونطاق الوظائف المطلوب. يسعدنا إعداد عرض فردي غير ملزم.' },
      },
    },
    cta: {
      title: 'لنكتشف معًا الحل الذي يناسب ممتلكاتك.',
      lead: 'اتصل بنا أو راسلنا أو ابدأ مباشرة بمخطط الكاميرات. سنرد عليك سريعًا.',
      primary: 'اطلب استشارة أولى مجانية',
      secondary: 'ابدأ مخطط الكاميرات',
    },
  },
  company: {
    solutions: {
      home: { title: 'المنزل والحديقة', description: 'من باب المدخل إلى المرآب – مراقبة سرية لمنزلك.' },
      retail: { title: 'تجارة التجزئة والمطاعم', description: 'منطقة الدفع والمدخل والمستودع – مؤمّنة باحترافية.' },
      office: { title: 'المكاتب والعيادات', description: 'الاستقبال والممرات والمناطق الحساسة – مخطط لها بمراعاة الخصوصية.' },
      warehouse: { title: 'المستودعات واللوجستيات', description: 'مراقبة مساحات واسعة بزاوية عريضة ورؤية ليلية.' },
      workshop: { title: 'الورش والصناعة', description: 'كاميرات متينة للبيئات القاسية – القاعات والمناطق الخارجية.' },
      apartment: { title: 'العمارات السكنية والعقارات', description: 'المداخل والسلالم والمرافق الخارجية – للمستأجرين والمالكين.' },
    },
  },
};